import * as XLSX from 'xlsx';

export const ACTIVE_AUTOMATION_PROFILE_CONTEXT_KEY = 'linktrust_active_automation_profile_context';

const canonicalFieldDefinitions = {
  campaignName: [
    'campaignname', 'campaign', 'offername', 'offer', 'name', 'title'
  ],
  payout: [
    'payout', 'affiliatepayout', 'defaultaffiliatepayout', 'cpa', 'cpl', 'costperaction', 'amount'
  ],
  category: [
    'category', 'campaigncategory', 'vertical', 'offercategory', 'payoutcategory', 'actualpayoutcategory'
  ],
  campaignType: [
    'type', 'campaigntype', 'model', 'pricingmodel', 'paymentmodel'
  ],
  description: [
    'description', 'notes', 'campaignnotes', 'specialinstructions', 'details'
  ],
  targetRules: [
    'targetrules', 'targetingrules', 'targeting', 'rules', 'rule', 'trafficrules'
  ],
  geo: [
    'geo', 'geography', 'geos', 'countries', 'country', 'region', 'locations'
  ],
  landingPageUrl: [
    'defaultlandingpageurl', 'landingpageurl', 'landingurl', 'destinationurl', 'url'
  ],
  trackingUrl: [
    'trackingurl', 'trackinglink', 'tracking', 'lpurl', 'offerurl', 'clickurl'
  ]
};

const canonicalLabels = {
  campaignName: 'Campaign Name',
  payout: 'Payout',
  category: 'Category',
  campaignType: 'Campaign Type',
  description: 'Description',
  targetRules: 'Target Rules',
  geo: 'Geo',
  landingPageUrl: 'Landing Page URL',
  trackingUrl: 'Tracking URL'
};

const creativeFieldDefinitions = {
  campaignId: ['campaignid', 'campaign_id', 'linktrustcampaignid', 'ltcampaignid'],
  campaignName: ['campaignname', 'campaign', 'offername', 'offer'],
  adId: ['adid', 'creativeid', 'creative_id', 'assetid'],
  creativeType: ['type', 'creativetype', 'creative_type', 'adtype'],
  name: ['name', 'creativename', 'creative_name', 'assetname', 'title'],
  content: ['content', 'html', 'markup', 'body', 'text', 'creativecontent'],
  sizeId: ['sizeid', 'size_id', 'bannerid'],
  customLandingPageUrl: ['customlandingpageurl', 'customlandingurl', 'landingpageurl', 'landingurl'],
  fileOrImageUrl: ['fileorimageurl', 'asseturl', 'imageurl', 'fileurl', 'creativeurl', 'url'],
  fileName: ['filename', 'assetfilename', 'imagefilename', 'file'],
  subject: ['subject', 'emailsubject'],
  groupId: ['groupid', 'group_id'],
  enabled: ['enabled', 'isenabled', 'active'],
  propagateAdditionalData: ['propagateadditionaldata', 'propageadditionaldata', 'propagate_data'],
  affiliatePayoutType: ['affiliatepayouttype', 'affiliate_payout_type'],
  affiliatePayout: ['affiliatepayout', 'payout'],
  advertiserRevenue: ['advertiserrevenue', 'revenue'],
  enableForAllAffiliates: ['enableforallaffiliates', 'enable_for_all_affiliates'],
  affiliateGroupId: ['affiliategroupid', 'affiliate_group_id'],
  showTrackingLinkInListing: ['showtrackinglinkinlisting', 'show_tracking_link_in_listing'],
  displaySubjectInAC: ['displaysubjectinac', 'display_subject_in_ac'],
  downloadOnlyForAllAffiliates: ['downloadonlyforallaffiliates', 'download_only_for_all_affiliates'],
  affiliates: ['affiliates', 'affiliateids', 'affiliate_ids']
};

const creativeLabels = {
  campaignId: 'Campaign ID',
  campaignName: 'Campaign Name',
  adId: 'ADID',
  creativeType: 'Type',
  name: 'Creative Name',
  content: 'Content',
  sizeId: 'Size ID',
  fileOrImageUrl: 'Asset URL',
  fileName: 'Asset Filename',
  subject: 'Subject'
};

export const campaignFieldOptions = [
  { value: '', label: 'Auto detect' },
  { value: 'campaignName', label: 'Campaign Name' },
  { value: 'payout', label: 'Payout' },
  { value: 'category', label: 'Category' },
  { value: 'campaignType', label: 'Campaign Type' },
  { value: 'description', label: 'Description' },
  { value: 'targetRules', label: 'Target Rules' },
  { value: 'geo', label: 'Geo' },
  { value: 'landingPageUrl', label: 'Landing Page URL' },
  { value: 'trackingUrl', label: 'Tracking URL' }
];

export const creativeFieldOptions = [
  { value: '', label: 'Auto detect' },
  { value: 'campaignId', label: 'Campaign ID' },
  { value: 'campaignName', label: 'Campaign Name' },
  { value: 'adId', label: 'ADID' },
  { value: 'creativeType', label: 'Creative Type' },
  { value: 'name', label: 'Creative Name' },
  { value: 'content', label: 'Content/HTML' },
  { value: 'sizeId', label: 'Size ID' },
  { value: 'customLandingPageUrl', label: 'Custom Landing URL' },
  { value: 'fileOrImageUrl', label: 'File/Image URL' },
  { value: 'fileName', label: 'File Name' },
  { value: 'subject', label: 'Subject' },
  { value: 'groupId', label: 'Group ID' },
  { value: 'enabled', label: 'Enabled' },
  { value: 'propagateAdditionalData', label: 'Propage Additional Data' },
  { value: 'affiliatePayoutType', label: 'Affiliate Payout Type' },
  { value: 'affiliatePayout', label: 'Affiliate Payout' },
  { value: 'advertiserRevenue', label: 'Advertiser Revenue' },
  { value: 'enableForAllAffiliates', label: 'Enable For All Affiliates' },
  { value: 'affiliateGroupId', label: 'Affiliate Group ID' },
  { value: 'showTrackingLinkInListing', label: 'Show Tracking Link In Listing' },
  { value: 'displaySubjectInAC', label: 'Display Subject In AC' },
  { value: 'downloadOnlyForAllAffiliates', label: 'Download Only For All Affiliates' },
  { value: 'affiliates', label: 'Affiliates' }
];

export const LINKTRUST_SESSION_CREDENTIALS_KEY = 'spacejet-linktrust-import-credentials';

const normalizeHeader = (header) => String(header || '').trim().toLowerCase().replace(/[^a-z0-9]/g, '');

const scoreHeaderRow = (row = [], definitions, fallbackResolver) => {
  return row.reduce((score, cell) => {
    const field = getFieldByHeader(cell, definitions, fallbackResolver);
    return field ? score + 1 : score;
  }, 0);
};

const matrixToObjects = ({ matrix, headerRowIndex, definitions, fallbackResolver }) => {
  const headerRow = matrix[headerRowIndex] || [];
  const headers = headerRow.map((cell, index) => {
    const text = String(cell || '').trim();
    return text || `Column ${index + 1}`;
  });

  const rows = [];
  for (let rowIndex = headerRowIndex + 1; rowIndex < matrix.length; rowIndex += 1) {
    const rawRow = matrix[rowIndex] || [];
    const objectRow = {};
    let hasValue = false;

    headers.forEach((header, colIndex) => {
      const value = rawRow[colIndex] == null ? '' : String(rawRow[colIndex]).trim();
      objectRow[header] = value;
      if (value) hasValue = true;
    });

    if (hasValue) {
      rows.push(objectRow);
    }
  }

  const mappedRows = rows.map((row, index) => {
    const { mapped, leftovers } = mapRecord(row, definitions, fallbackResolver);
    return { index, source: row, mapped, leftovers };
  });

  return { rows, headers, mappedRows };
};

const getFieldByHeader = (header, definitions, fallbackResolver) => {
  const normalized = normalizeHeader(header);
  if (!normalized) return null;

  for (const [field, aliases] of Object.entries(definitions)) {
    if (aliases.includes(normalized)) {
      return field;
    }
  }

  return fallbackResolver(normalized);
};

const campaignFallbackResolver = (normalized) => {
  if (normalized.includes('campaign') && normalized.includes('name')) return 'campaignName';
  if (normalized.includes('payout') && normalized.includes('category')) return 'category';
  if (normalized.includes('target')) return 'targetRules';
  if (normalized.includes('geo') || normalized.includes('country')) return 'geo';
  if (normalized.includes('tracking') && normalized.includes('url')) return 'trackingUrl';
  if ((normalized.includes('landing') || normalized.includes('default')) && normalized.includes('url')) return 'landingPageUrl';
  if (normalized.includes('description') || normalized.includes('note')) return 'description';
  if (normalized.includes('type') || normalized.includes('model')) return 'campaignType';
  return null;
};

const creativeFallbackResolver = (normalized) => {
  if (normalized.includes('campaign') && normalized.includes('id')) return 'campaignId';
  if (normalized.includes('campaign') && normalized.includes('name')) return 'campaignName';
  if ((normalized.includes('creative') || normalized.includes('ad')) && normalized.includes('type')) return 'creativeType';
  if ((normalized.includes('file') || normalized.includes('image') || normalized.includes('asset')) && normalized.includes('url')) return 'fileOrImageUrl';
  if ((normalized.includes('file') || normalized.includes('image') || normalized.includes('asset')) && normalized.includes('name')) return 'fileName';
  if (normalized === 'html' || normalized === 'content' || normalized === 'text') return 'content';
  return null;
};

const isBlankValue = (value) => value == null || String(value).trim() === '';

const coerceValue = (value) => {
  if (value == null) return '';
  if (typeof value === 'number') return String(value);
  if (typeof value === 'boolean') return value ? 'true' : 'false';
  return String(value).trim();
};

const mapRecord = (record = {}, definitions, fallbackResolver) => {
  const mapped = {};
  const leftovers = [];

  Object.entries(record).forEach(([rawHeader, rawValue]) => {
    const value = coerceValue(rawValue);
    if (isBlankValue(value)) return;

    const field = getFieldByHeader(rawHeader, definitions, fallbackResolver);
    if (!field) {
      leftovers.push({ key: String(rawHeader || 'Unknown'), value });
      return;
    }

    if (mapped[field]) {
      mapped[field] = `${mapped[field]} | ${value}`;
    } else {
      mapped[field] = value;
    }
  });

  return { mapped, leftovers };
};

const decodeWorksheet = (sheet) => XLSX.utils.sheet_to_json(sheet, { defval: '', raw: false });

const parseImportFileWithMappings = async ({ file, definitions, fallbackResolver }) => {
  const arrayBuffer = await file.arrayBuffer();
  const workbook = XLSX.read(arrayBuffer, { type: 'array' });
  const [firstSheetName] = workbook.SheetNames;
  if (!firstSheetName) {
    return { rows: [], headers: [], mappedRows: [] };
  }

  const sheet = workbook.Sheets[firstSheetName];
  const matrix = XLSX.utils.sheet_to_json(sheet, { header: 1, defval: '', raw: false });
  const scanLimit = Math.min(matrix.length, 20);
  let bestHeaderRowIndex = 0;
  let bestScore = -1;

  for (let index = 0; index < scanLimit; index += 1) {
    const score = scoreHeaderRow(matrix[index], definitions, fallbackResolver);
    if (score > bestScore) {
      bestScore = score;
      bestHeaderRowIndex = index;
    }
  }

  if (bestScore > 0) {
    return {
      ...matrixToObjects({ matrix, headerRowIndex: bestHeaderRowIndex, definitions, fallbackResolver }),
      headerRowIndex: bestHeaderRowIndex
    };
  }

  const rows = decodeWorksheet(sheet);
  const headers = rows.length ? Object.keys(rows[0]) : [];
  const mappedRows = rows.map((row, index) => {
    const { mapped, leftovers } = mapRecord(row, definitions, fallbackResolver);
    return {
      index,
      source: row,
      mapped,
      leftovers
    };
  });

  return { rows, headers, mappedRows, headerRowIndex: 0 };
};

export const parseImportFile = async (file) => {
  return parseImportFileWithMappings({
    file,
    definitions: canonicalFieldDefinitions,
    fallbackResolver: campaignFallbackResolver
  });
};

export const parseCreativeImportFile = async (file) => parseImportFileWithMappings({
  file,
  definitions: creativeFieldDefinitions,
  fallbackResolver: creativeFallbackResolver
});

export const summarizeMappedRow = (row) => {
  const mappedEntries = Object.entries(row?.mapped || {});
  if (!mappedEntries.length) {
    return 'No recognized fields';
  }

  return mappedEntries
    .slice(0, 4)
    .map(([field, value]) => `${canonicalLabels[field] || field}: ${String(value).slice(0, 60)}`)
    .join(' | ');
};

export const summarizeCreativeMappedRow = (row) => {
  const mappedEntries = Object.entries(row?.mapped || {});
  if (!mappedEntries.length) {
    return 'No recognized creative fields';
  }

  return mappedEntries
    .slice(0, 4)
    .map(([field, value]) => `${creativeLabels[field] || field}: ${String(value).slice(0, 60)}`)
    .join(' | ');
};

export const suggestCreativeTypeFromFile = (file) => {
  const mimeType = String(file?.type || '').toLowerCase();
  const name = String(file?.name || '').toLowerCase();

  if (mimeType.includes('text/html') || name.endsWith('.html') || name.endsWith('.htm')) {
    return { type: 2, label: 'HTML' };
  }
  if (mimeType.startsWith('text/')) {
    return { type: 1, label: 'Text' };
  }
  if (mimeType.startsWith('image/')) {
    return { type: 6, label: 'Simple_Banner' };
  }
  return { type: 8, label: 'File' };
};

export const suggestCampaignFieldByHeader = (header) => getFieldByHeader(header, canonicalFieldDefinitions, campaignFallbackResolver) || '';
export const suggestCreativeFieldByHeader = (header) => getFieldByHeader(header, creativeFieldDefinitions, creativeFallbackResolver) || '';

export const remapRowsByFieldOverrides = (rows = [], overrides = {}) => {
  const resolvedOverrides = overrides || {};
  return rows.map((row = {}) => {
    const rebuilt = {};
    Object.entries(row).forEach(([sourceHeader, rawValue]) => {
      const targetField = String(resolvedOverrides[sourceHeader] || '').trim();
      const targetKey = targetField || sourceHeader;
      const value = rawValue == null ? '' : String(rawValue);
      if (!value) return;

      if (rebuilt[targetKey]) {
        rebuilt[targetKey] = `${rebuilt[targetKey]} | ${value}`;
      } else {
        rebuilt[targetKey] = value;
      }
    });
    return rebuilt;
  });
};
